//types
import {IOrganizationTableTicketsRequest, IOrganizationTableTicketsResponse} from '@/utils/types';

export const getEditTableDetailsValues = (
	tableDetails: IOrganizationTableTicketsResponse
): IOrganizationTableTicketsRequest => {
	const {name, number, isPaid, tickets, purchaser, tableInfo} = tableDetails;

	const editValues = {
		name,
		number,
		isPaid,
		purchaser,
		tableInfo: {
			id: tableInfo.id,
			tier: tableInfo.tier,
			numberOfSeats: tableInfo.numberOfSeats,
			amount: tableInfo.amount,
			price: +tableInfo.price,
			eventId: tableInfo.eventId,
		},
		tickets: tickets.map((ticket) => ({
			id: ticket.id,
			email: ticket.email || '',
			firstName: ticket.firstName || '',
			lastName: ticket.lastName || '',
			phoneNumber: ticket.phoneNumber || '',
			meals: ticket.meals,
			isVIP: ticket.isVIP,
			isUnknown: !(ticket.id && ticket.email && ticket.firstName && ticket.lastName && ticket.phoneNumber),
		})),
	};

	return editValues;
};
